export default "__VITE_ASSET__D$dD31C1__"